import React from 'react'
import { Link, useLocation } from 'react-router-dom'

interface WithdrawSuccessBannerProps {
  employeeName?: string
  requestId?: string
  submittedOn?: string
  requestedDates?: string
}

const WithdrawSuccessBanner: React.FC<WithdrawSuccessBannerProps> = () => {
  const location = useLocation()
  const isAdminMode = location?.pathname?.startsWith?.('/admin') || false
  return(
  <div data-testid="withdraw-success-banner">
    <div className="mb-6! bg-white">
      <div
        className="ds-banner ds-banner__bg--white ds-banner--icon p-3 mb-0 w-full flex flex-row items-start gap-3"
        data-ds-variant="basic"
        data-ds-version="1"
        data-ds-theme="vessel"
        aria-labelledby="success-banner-title"
        style={{ borderColor: '#003B71' }}
      >
        <div className="ds-banner__icon-img shrink-0">
          <img src="/assets/images/informationIcon.svg" alt="info icon" style={{ width: '42px', height: '42px' }} />
        </div>
        <div className="ds-banner__container flex-1">
          <div className="ds-banner__main flex flex-col gap-0">
            <div
              className="ds-banner__main-header--awareness"
              id="success-banner-title"
              style={{ fontWeight: 350, fontSize: '20px' }}
            >
              Withdraw Time Off Request Successful
            </div>
            <div className="ds-banner__main-body text-sm leading-tight">
              This Time Off Request was successfully withdrawn. You can view the details of this request in the My Time Off Request Tab
            </div>
            <Link to={isAdminMode?"/admin/requestor":"/requestor"} className="underline">Back to TORT</Link>
          </div>
        </div>
      </div>
      {/* <div className="mt-6! grid grid-cols-1">
        {employeeName && <LabeledValue label="Time Off Request For" value={employeeName} />}
        {requestedDates && <LabeledValue label="Time Off Request Dates" value={requestedDates} />}
        {requestId && <LabeledValue label="Time Off Request ID" value={requestId} />}
        {submittedOn && <LabeledValue label="Submitted On" value={submittedOn} />}
      </div> */}
    </div>
  </div>
)}

export default WithdrawSuccessBanner
